import { FeatureCollection } from 'geojson'
import { useHasFilters, useHighlightIds } from 'map-filter-view'
import { getClusterFilterPayload } from 'map-style-utils'
import { Source } from 'ms-map-gl'
import { FC, useMemo } from 'react'

import { geojsonify } from '~map-preview/utils/geojsonify'
import { ClusterLayer } from '../../Layers/MarkerLayer/Cluster'

type ClusterSourceProps = {
  geojson?: FeatureCollection
}

export const ClusterSource: FC<ClusterSourceProps> = geojsonify((props) => {
  const { geojson } = props

  const filterIds = useHighlightIds()
  const hasFilters = useHasFilters()

  const { filter } = useMemo(
    () => getClusterFilterPayload(filterIds),
    [filterIds]
  )

  const key = useMemo(
    () => `mapstack-points-cluster-${filterIds.join('-')}`,
    [filterIds]
  )

  return (
    <Source
      cluster
      key={key}
      id='mapstack-points-cluster'
      type='geojson'
      data={geojson}
      filter={hasFilters ? filter : undefined}
      clusterMaxZoom={14}
      // INFO: This is property for hover feature state
      promoteId={'cluster_id'}
    >
      <ClusterLayer />
    </Source>
  )
})
